import React from 'react';

const SvgChevronLeft = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <defs>
      <path
        id="chevronLeft_svg__a"
        d="M13.895 16L25 28.668 21.025 32 7 16 21.025 0 25 3.332z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="chevronLeft_svg__b" fill="#fff">
        <use xlinkHref="#chevronLeft_svg__a" />
      </mask>
      <use
        fill="currentColor"
        fillRule="nonzero"
        xlinkHref="#chevronLeft_svg__a"
      />
      <g fill="currentColor" fillRule="nonzero" mask="url(#chevronLeft_svg__b)">
        <path d="M0 0h32v32H0z" />
      </g>
    </g>
  </svg>
);

export default SvgChevronLeft;
